var inscritosTable = null;
var esVue = null;
var esAdmin = null;
var num_inscrito_sel = 0;
var localidades_fechas_elegidas = [];
var map_interval;
function actividadesInscritosViewCallback(buttons, select_name, filtrar_estado_lista_espera) {

    inscritosTable = $("#inscritosViewTable").DataTable({
        language: {
            url: '/vendor/datatables-i18n/i18n/' + lang + '.json'
        },
        dom: 'lfBrtip',
        search: { smart: false },
        buttons: buttons,
        initComplete: function () {
            // Solo si ha encontrado un select de filtrado.
            if(select_name != null) filtrado_lista_espera(select_name, filtrar_estado_lista_espera);
        }
    });
}

function sincronizar_texto_tutor($editor){
    var $wrapper = $editor.closest('.texto_tutor_editor_wrapper');
    $wrapper.find('textarea[name=texto_tutor]').val($editor.html());
}

$(document).on('mousedown', '.texto_tutor_toolbar button', function(e){
    e.preventDefault();
});

$(document).on('input blur', '.texto_tutor_editor', function(){
    sincronizar_texto_tutor($(this));
});

$(document).on('click', '.texto_tutor_cmd', function(e){
    e.preventDefault();
    var $wrapper = $(this).closest('.texto_tutor_editor_wrapper');
    var $editor = $wrapper.find('.texto_tutor_editor');
    $editor.focus();
    document.execCommand($(this).data('command'), false, null);
    sincronizar_texto_tutor($editor);
});

$(document).on('click', '.texto_tutor_link', function(e){
    e.preventDefault();
    var url = prompt('URL');
    if(!url){
        return;
    }

    var $wrapper = $(this).closest('.texto_tutor_editor_wrapper');
    var $editor = $wrapper.find('.texto_tutor_editor');
    $editor.focus();
    document.execCommand('createLink', false, url);
    sincronizar_texto_tutor($editor);
});

$(document).on('submit', 'form', function(){
    $(this).find('.texto_tutor_editor').each(function(){
        sincronizar_texto_tutor($(this));
    });
});

function filtrado_lista_espera(select_name, filtrar_estado_lista_espera){

    // Ajustando elementos.
    var $filter_row = $("#inscritosViewTable_wrapper .dataTables_filter");
    var $select = $("#select_campo_opcion").parent();
    var $flex_wrapper = $('<div class="custom_filter_wrapper"></div>');
    $filter_row.before($flex_wrapper);
    $select.appendTo($flex_wrapper);
    $filter_row.appendTo($flex_wrapper);

    // Índices de búsqueda de columna.
    var select_index = -1;
    var estado_index = -1;

    // Buscando índices de las columnas.
    $('#inscritosViewTable thead th').each(function(index) {
        if($(this).text().includes(select_name)) select_index = index;
    });

    if (filtrar_estado_lista_espera) {
        $('#inscritosViewTable tbody tr').each(function(row_index, row) {
            $(row).find('td').each(function(cell_index, cell) {
                if ($(cell).attr('id') && $(cell).attr('id').includes('estado_listaespera')) {
                    estado_index = cell_index;
                    return true;
                }
            });
            if (estado_index != -1) return true;
        });
    }

    // Buscando el valor de la lista de espera.
    var lista_espera = '';
    if (filtrar_estado_lista_espera) {
        lista_espera = $('tr[data-estado_listaespera="1"]')
            .find('td[id*="estado_listaespera"]')
            .first()
            .text()
            .trim();
    }
    
    // Filtrado
    $('#select_campo_opcion').on('change', function() {
        var option_value = $(this).val();
        if(option_value != ''){

            if (select_index >= 0) {
                inscritosTable.columns().search('');
                inscritosTable.column(select_index).search(option_value);
                if (filtrar_estado_lista_espera && estado_index >= 0) {
                    inscritosTable.column(estado_index).search(lista_espera);
                }
                inscritosTable.draw();
            }
            else inscritosTable.columns().search('').draw();
        }
        else inscritosTable.columns().search('').draw();

    }); 

}

$(document).on('click', '.eliminaInscrito', function () {
    var activar_pago = $(this).closest('#inscritosRow').data('activar_pago');
    $("#eliminarInscritoModal .sureDelete[data-activar_pago=0]").addClass('hidden');
    $("#eliminarInscritoModal .sureDelete[data-activar_pago=1]").addClass('hidden');
    $("#eliminarInscritoModal .sureDelete[data-activar_pago=" + activar_pago + "]").removeClass('hidden');
    $("#inscritosViewTable tr").removeClass('deleting');
    $(this).closest('tr').addClass('deleting');
    $("#eliminarInscritoModal").css('z-index', '1060');
    $("#eliminarInscritoModal").modal('show');
});

$(document).on('click', '.descargar_adjuntos, .descargar_todos_adjuntos', function () {
    var url;
    if ($(this).hasClass('descargar_adjuntos')) {
        var id_reg_actividades_inscritos = $(this).closest('#inscritosRow').data('id_reg_actividades_inscritos');
        var url = '/descargar_adjuntos/' + id_reg_actividades_inscritos;
    } else if ($(this).hasClass('descargar_todos_adjuntos')) {
        var id_reg_actividades_grupo = $(this).attr('id_reg_actividades_grupo');
        var url = '/descargar_adjuntos_actividad/' + id_reg_actividades_grupo;
    }

    iniciar_proces(url, false);
});

$(document).on('click', '.descargar_todos_adjuntos_agrupados', function () {
    var id_reg_actividades_grupo = $(this).attr('id_reg_actividades_grupo');
    var url = '/descargar_adjuntos_actividad_agrupado/' + id_reg_actividades_grupo;
    iniciar_proces(url, true);
});

$(document).on('click', '.eliminar_todos_adjuntos', function () {

    $("#eliminar_adjuntos_modal").css('z-index', '1060');
    $("#eliminar_adjuntos_modal").modal('show');
});

$(document).on('click', '.elimina_adjunto_confirma', function () {
    var id_reg_actividades_grupo = $('.eliminar_todos_adjuntos').attr('id_reg_actividades_grupo');
    var url = '/eliminar_adjuntos_actividad/' + id_reg_actividades_grupo;

    fetch(url)
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {         
            if(data.status){              
                $("#eliminar_adjuntos_modal").css('z-index', '-1');
                $("#eliminar_adjuntos_modal").modal('hide');
                $("#modal_c").modal('hide');
            }
        })
        .catch(function(error)  { return error;});
});


$(document).on('click', '.validarInscritoMenor', function () {
    $.get("/actividad/inscripcion/validar_nif_menor?id_reg_actividad_inscrito=" + $('#id_reg_actividades_inscritos_input').val(),function (result) {
        window.location.href = "/view/reserves/admin_actividades";
    });
});

function iniciar_proces(url, agrupado) {
    if (typeof agrupado === 'undefined') agrupado = false;
    var dir_handle;

    window.showDirectoryPicker()
        .then(function (handle) {
            dir_handle = handle;
            return fetch(url);
        })
        .then(function (response) {
            return response.json();
        })
        .then(function (result) {

            return crear_carpeta(dir_handle, result.nombre_grupo).then(function (grupo_dir) {
                if (!grupo_dir) return;

                if (agrupado && result.carpetas) {
                    var promises = result.carpetas.map(function(carpeta) {
                        return grupo_dir.getDirectoryHandle(carpeta.id_inscrito.toString(), { create: true })
                            .then(function(inscrito_dir) {
                                guardar_carpeta(carpeta.files, inscrito_dir)
                            });
                    });
                    return Promise.all(promises);
                } else if (result.files) {
                    return guardar_carpeta(result.files, grupo_dir);
                }
            });
        })
        .catch(function (error) {
            descargar_normal(url);
        });
}

function guardar_carpeta(files, subdir_handle) {
    var promises = files.map(function (file) {
        return fetch(file.url).then(function (file_response) {
            return file_response.blob().then(function (blob) {
                return subdir_handle.getFileHandle(file.name, { create: true }).then(function (file_handle) {
                    return file_handle.createWritable().then(function (writable) {
                        return writable.write(blob).then(function () {
                            return writable.close();
                        });
                    });
                });
            });
        }).catch(function (error) {
            console.error('Error guardar fitxers');
        });
    });

    return Promise.all(promises);
}

function crear_carpeta(dir_handle, nombre_carpeta) {
    return dir_handle.getDirectoryHandle(nombre_carpeta, { create: true })
        .then(function(subdir_handle) {
            return subdir_handle;
        })
        .catch(function(error) {
            return null;
        });
}

function descargar_normal(request_url) {
    fetch(request_url).then(function (response) {
        return response.json();
    }).then(function (result) {
        result.files.forEach(function (file) {
            var link = document.createElement('a');
            link.href = file.url;
            link.download = '';
            link.click();
        });
    });
}

$(document).on('click', '.enviar-links', function () {
    var activar_pago = $(this).closest('#inscritosRow').data('activar_pago');
    $('#enviar-links').modal('show');

    var id_reg_actividades_grupo = $(this).attr('id_reg_actividades_grupo');

    var id_reg_actividades_inscritos = $(this).closest('#inscritosRow').data('id_reg_actividades_inscritos');

    var estado_listaespera = $(this).closest('#inscritosRow').data('estado_listaespera');

    var enviar_todos = $(this).attr('enviar_todos');

    if (enviar_todos) {
        document.getElementById('enviar_todos').value = 1;
    }

    if (estado_listaespera !== 1){
        document.getElementById('email_inscrito_listaespera_body').classList.add('hidden');
    }else {
        document.getElementById('email_inscrito_listaespera_body').classList.remove('hidden');
    }
    document.getElementById('id_reg_actividades_inscritos_concepto').value = id_reg_actividades_inscritos;

    $.get('get_actividad_grupo/' + id_reg_actividades_grupo, {}, function (result) {
        if (result.pedir_importe_fijo == 1) {
            var importe_fijo = result.importe_fijo;
            var concepto_importe_fijo = result.precio_fijo_concepto;
            document.getElementById('importe_fijo_actividad_valor').value = importe_fijo;
            document.getElementById('importe_fijo_actividad_concepto').value = concepto_importe_fijo;
            if (importe_fijo > 0) {
                $('#importe_fijo_actividad_valor').prop('disabled', true);
                $('#importe_fijo_actividad_concepto').prop('disabled', true);
            }
        } else {
            document.getElementById('email_inscrito_body').classList.add('hidden');
        }
    })
});

$(document).on('click', '#btn-enviar-links', function () {
    document.getElementById('importe_fijo_actividad_valor').style.border = '';
    document.getElementById('importe_fijo_actividad_concepto').style.border = '';
    var id_reg_actividades_inscritos = document.getElementById('id_reg_actividades_inscritos_concepto').value;

    var data;
    //var id_reg_actividades_grupo = $('#btn-enviar-todos').attr('id_reg_actividades_grupo');
    var enviar_todos = document.getElementById('enviar_todos').value;


    if (enviar_todos) {
        var id_reg_actividades_grupo = $('#btn-enviar-todos').attr('id_reg_actividades_grupo');
        data = {
            id_reg_actividades_grupo: id_reg_actividades_grupo,
            importe_fijo: document.getElementById('importe_fijo_actividad_valor').value,
            importe_fijo_actividad_concepto: document.getElementById('importe_fijo_actividad_concepto').value,
        };
    } else {
        data = {
            importe_fijo: document.getElementById('importe_fijo_actividad_valor').value,
            importe_fijo_actividad_concepto: document.getElementById('importe_fijo_actividad_concepto').value,
        };
    }

    $.post('enviar_email_links/' + id_reg_actividades_inscritos, data, function (result) {
        if (result.status == 1) {
            document.getElementById('importe_fijo_actividad_valor').style.border = '1px solid red';
            document.getElementById('importe_fijo_actividad_concepto').style.border = '1px solid red';
        } else {

            document.getElementById('importe_fijo_actividad_valor').style.border = '';
            document.getElementById('importe_fijo_actividad_concepto').style.border = '';
            if (result.status == 2) {
                var data_formatada = moment(result.data.date).format('DD/MM/YYYY');
                document.getElementById('fecha_enlaces_pago_posterior-' + id_reg_actividades_inscritos).innerText = data_formatada;
                document.getElementById('fecha_pagado_posterior-' + id_reg_actividades_inscritos).innerText = data_formatada;
                if(result.data.texto_pendiente_pago) {
                    document.getElementById('estado_listaespera-' + id_reg_actividades_inscritos).innerText = result.data.texto_pendiente_pago;
                    document.getElementById('estado_sorteo-' + id_reg_actividades_inscritos).innerText = result.data.texto_pendiente_pago;
                }
                $('#enviar-links').modal('hide');
                return;
            }

            if (result.data.fecha !== undefined) {
                //var data_formatada = moment(result.data.fecha).format('DD/MM/YYYY');
                document.getElementById('fecha_enlaces_pago_posterior-' + id_reg_actividades_inscritos).innerText = result.data.fecha;               
                if( document.getElementById("fecha_importe_fijo_pago_posterior-" + id_reg_actividades_inscritos)){
                    document.getElementById('fecha_importe_fijo_pago_posterior-' + id_reg_actividades_inscritos).innerText = result.data.fecha;
                }
            }
            if (result.data.importe_fijo !== undefined && document.getElementById("importe_fijo_pago_posterior-" + id_reg_actividades_inscritos)) {
                document.getElementById('importe_fijo_pago_posterior-' + id_reg_actividades_inscritos).innerText = result.data.importe_fijo;
            }

            $('#enviar-links').modal('hide');
        }
    });
});

$(document).on('click', '.eliminaInscritoConfirma', function () {
    var id_reg_actividades_inscritos = $("#inscritosViewTable tr.deleting").data('id_reg_actividades_inscritos');
    $('#eliminarInscritoModal').modal('toggle');
    $.post('/api/actividades/inscritos/' + id_reg_actividades_inscritos + '/destroy', {}, function () {
        inscritosTable
            .row($("tr[data-id_reg_actividades_inscritos=" + id_reg_actividades_inscritos + "]"))
            .remove()
            .draw();
        var nInscrits = parseInt($("#nInscrits").html()) - 1;
        nInscrits = nInscrits < 0 ? 0 : nInscrits;
        $("#nInscrits").html(nInscrits);
    });
});

$(document).on('click', '.emailInscrito', function () {
    var id_reg_actividades_inscritos = $(this).closest('#inscritosRow').data('id_reg_actividades_inscritos');

    $.get('/view/reserves/actividad/actividad_grupo/email_inscrito/' + id_reg_actividades_inscritos, {}, function (email) {
        $("#emailInscritoModalBody").html(email);
        $("#emailInscritoModal").css('z-index', '1060');
        $("#emailInscritoModal").modal('show');
    });
});

var actividades = {
    inscripcion: {
        vue: null,
        newVue: function () {
            actividades.inscripcion.vue = new Vue({
                'el': '#inscripcionFormulario',
                data: {
                    usuarios: [],
                    usuario_actual: null,
                    solo_un_inscrito: false,
                    llenar_campos_con_mis_datos_btn: true,
                    calrefresh: true,
                    caldelete: -1
                },
                methods: {
                    addUser: function () {
                        var self = this;
                        var usuario = {
                            nombre: null,
                            apellidos: null,
                            nif: null,
                            email: null,
                            document: []
                        }
                        self.calrefresh = true;
                        self.usuarios.push(usuario);
                        this.$nextTick(function () {
                            var $ultimoPanel = $('.panel.panel-default').eq(self.usuarios.length - 1);
                            aplicar_dependencias($ultimoPanel);
                            aplicar_filtros($ultimoPanel);
                        });
                    },
                    deleteUser: function (key) {
                        var self = this;
                        self.caldelete = key;
                        self.$delete(this.usuarios, key);
                    },
                    getUsuarioActual: function (event) {
                        event.preventDefault();
                        var self = this;
                        esAdmin = false;
                        axios.get('/api/socio/getUsuarioActual').then(function (res) {
                            self.llenar_campos_con_mis_datos_btn = false;
                            self.usuario_actual = res.data;
                            self.usuarios[0].nombre = self.usuario_actual.nombre;
                            self.usuarios[0].apellidos = self.usuario_actual.apellidos;
                            self.usuarios[0].nif = self.usuario_actual.nif;
                            self.usuarios[0].email = self.usuario_actual.email;
                            self.usuarios[0].campos_disabled = true;
                            self.usuarios[0].campos_disabled_nif = true;

                            if ($('#crearUsuariosPermitirModificarDatos').val() === '0') {
                                self.usuarios[0].campos_disabled2 = true;
                            } else {
                                self.usuarios[0].campos_disabled2 = false;
                            }
                            var idRegPlantilla = $('#idRegPlantilla').val();

                            axios.get('/api/plantilla/getUserFields/' + idRegPlantilla).then(function (resPlantilla) {
                                llenarCamposPlantillaSocio(res.data, resPlantilla.data, 0);
                                recargar_dropzone_foto_perfil(0, res.data.path_imagen || '');
                            });
                        });
                    },
                    limpiarCamposAutocompletados: function (event) {
                        if (event) event.preventDefault();
                    
                        var self = this;
                        if (!self.usuarios || self.usuarios.length === 0) return;
                        
                        self.usuario_actual = null;
                        self.usuarios[0].nombre = null;
                        self.usuarios[0].apellidos = null;
                        self.usuarios[0].nif = null;
                        self.usuarios[0].email = null;
                        self.usuarios[0].campos_disabled = false;
                        self.usuarios[0].campos_disabled_nif = false;
                        self.usuarios[0].campos_disabled2 = false;

                        var idRegPlantilla = $('#idRegPlantilla').val();
                        axios.get('/api/plantilla/getUserFields/' + idRegPlantilla).then(function (resPlantilla) {
                            limpiar_campos_plantilla_socio(resPlantilla.data, 0);
                            limpiar_dropzone_foto_perfil(0);
                            self.llenar_campos_con_mis_datos_btn = true;
                        });
                    },
                    selUsuarioActual: function (event, key) {
                        event.preventDefault();
                        esVue = true;
                        esAdmin = true;
                        num_inscrito_sel = key;
                        sel_soci_get_users({
                            'name': '00000',
                            'id_inscrito': key
                        });
                    },
                    noNIFUsuarioActual: function (event, key) {
                        var self = this;
                        if (event.srcElement.checked == true) {
                            self.usuarios[key].nif = '-';
                            self.usuarios[key].campos_disabled_nif = true;
                        } else {
                            self.usuarios[key].nif = '';
                            self.usuarios[key].campos_disabled_nif = false;
                        }
                    },
                    refreshCamps: function (iniflat) {
                        // Primer hem de recorre tots els camps per canviar ids
                        var primercamp = 0;
                        var primercamp_secundaria = 0;
                        var numusuari = 1;
                        var numusuari_text = 'id1_'
                        $('.campo').each(function (key, campo) {
                            var numcampo = $(this).data('id_reg_plantilla_campo');
                            var num_campo_sec = $(this).data('id_reg_plantilla_campo_sec');
                            if (typeof (numcampo) !== 'undefined') {
                                if (primercamp === 0) {
                                    primercamp = numcampo;
                                }
                                else {
                                    if ((primercamp_secundaria === 0) && (typeof (num_campo_sec) !== 'undefined')) {
                                        primercamp_secundaria = num_campo_sec;
                                    } else {
                                        if ((numcampo == primercamp) || (numcampo == primercamp_secundaria)) {
                                            numusuari += 1;
                                            numusuari_text = 'id' + numusuari.toString() + '_';
                                        }
                                    }
                                }
                                var input = $(this).find('.form-control');
                                if (($(this).data('tipocampo') != 'statictext') && ($(this).data('tipocampo') != 'attach')) {
                                    if (($(this).data('tipocampo') === 'eligible')) {
                                        var inputfil2 = $(this).find('.elegible_plantilla');
                                        var numusuari_ini_text = 'fecha_ini' + numusuari.toString() + '_';
                                        var numusuari_fin_text = 'fecha_fin' + numusuari.toString() + '_';
                                        var numusuari_alert_text = 'alert' + numusuari.toString() + '_';
                                        var numusuari_dias_text = 'dias_elegibles' + numusuari.toString() + '_';
                                        inputfil2.each(function (key, elem) {
                                            var idact3 = $(elem).prop('id');
                                            if (key === 0) {
                                                idact3 = idact3.replace('fecha_ini1_', numusuari_ini_text);
                                            }
                                            if (key === 1) {
                                                idact3 = idact3.replace('fecha_fin1_', numusuari_fin_text);
                                            }
                                            $(elem).prop('id', idact3);
                                        });
                                        var alert = $(this).find('.alert-info');
                                        var idalert = alert.prop('id');
                                        idalert = idalert.replace('alert1_', numusuari_alert_text);
                                        alert.prop('id', idalert);
                                        var dias = $(this).find('.dias-info');
                                        var iddias = dias.prop('id');
                                        iddias = iddias.replace('dias_elegibles1_', numusuari_dias_text);
                                        dias.prop('id', iddias);
                                    } else {
                                        if (($(this).data('tipocampo') != 'checkbox') &&
                                            ($(this).data('tipocampo') != 'selectmultiple') &&
                                            ($(this).data('tipocampo') != 'selectmultipleinscripcion')
                                        ) {
                                            var idact = input.prop('id');
                                            idact = idact.replace('id1_', numusuari_text);
                                            input.prop('id', idact);
                                        } else {
                                            var inputfill = $(this).find('div');
                                            var idact2 = inputfill.prop('id');
                                            idact2 = idact2.replace('id1_', numusuari_text);
                                            inputfill.prop('id', idact2);
                                        }
                                    }
                                }
                            }
                            // control pels attachments
                            numcampo = $(this).data('id_attachmentupload');
                            if (typeof (numcampo) !== 'undefined') {
                                var idact_attachment = $(this).prop('id');
                                idact_attachment = idact_attachment.replace('id1_', numusuari_text);
                                $(this).prop('id', idact_attachment);
                            }

                            // control pels documents, llista arxius per usuari
                            numcampo = $(this).data('id_documento_obligatorio');
                            if (typeof (numcampo) !== 'undefined') {
                                var idact_document = $(this).prop('id');
                                idact_document = idact_document.replace('id1_', numusuari_text);
                                $(this).prop('id', idact_document);
                            }

                        });
                        // Canvia l´últim
                        if (iniflat === 1) {
                            inicializar_horas_dias_flatpickr(numusuari);
                        }

                        // funcio de actividad_inscripcio.blade
                        inicialitzarDOM();
                    },
                    deleteCamp: function (key) {
                        // funcio de actividad_inscripcio.blade
                        esborrarUsuari(key + 1);
                    }
                },
                mounted: function () {
                    if ($('#esAdmin').val() === "1" && ($('#activar_pago').val() === '1' || $('#activar_pago_posterior').val() === '1')) {
                        // alert("admin de pago");
                        $("#modalPagoAdmin").modal('show');
                    }

                    var self = this;
                    if (typeof self.$refs.panel_usuarios !== 'undefined') {
                        self.addUser();
                        self.solo_un_inscrito = self.$refs.panel_usuarios.dataset.solo_un_inscrito == '1' ? true : false;
                    } else {
                        self.addUser();
                    }

                    this.$nextTick(function () {
                        var $ultimoPanel = $('.panel.panel-default').eq(self.usuarios.length - 1);
                        aplicar_dependencias($ultimoPanel);
                        aplicar_filtros($ultimoPanel);

                        var esAdminActual = $('#esAdmin').val() === "1";
                        var esLogueado = $('#esLogueado').val() === "1";
                        var crear_usuarios = 0;
                        if (typeof self.$refs.panel_usuarios !== 'undefined') {
                            crear_usuarios = parseInt(self.$refs.panel_usuarios.dataset.crear_usuarios || '0');
                        }

                        if (!esAdminActual && esLogueado && crear_usuarios === 2 && self.usuarios.length > 0) {
                            self.getUsuarioActual({ preventDefault: function () {} });
                        }
                    });
                },
                updated: function () {
                    var self = this;
                    if (self.calrefresh === true) {
                        self.refreshCamps(1);
                        self.calrefresh = false;
                    } else {
                        if (self.caldelete > -1) {
                            self.deleteCamp(self.caldelete);
                            self.caldelete = -1;
                        }
                    }
                }
            });
        },
        onSave: function () {
            $("#loading_spin").fadeIn(100);

            var documents_individuals = null;
            if ((actividades.inscripcion.vue.usuario_actual !== null) && (esAdmin === false)) {
                $('.usuarios .usuario').first().append('<input type="hidden" value = "1" name="inscrito[0][crear_usuario][usuari_existent]"/>');
            }

            if (actividades.inscripcion.vue.usuarios.length === 1) { // Hem fet un usuari amagat per tenir els documents
                for (var i = 0; i < actividades.inscripcion.vue.usuarios[0].document.length; i++) {
                    if (documents_individuals === null) {
                        documents_individuals = actividades.inscripcion.vue.usuarios[0].document[i];
                    } else {
                        documents_individuals = documents_individuals + ",";
                        documents_individuals = documents_individuals + actividades.inscripcion.vue.usuarios[0].document[i];
                    }
                }
                $('#id1_documento_obligatorio').val(documents_individuals);
            }

            $('.usuarios .usuario').each(function (key, usuario) {

                $(usuario).find('.crear_usuario').each(function () {
                    var input = $(this).find('.form-control');
                    var newName = 'inscrito[' + key + '][crear_usuario][' + input.data('original_name') + ']';
                    input.attr('name', newName);

                });

                $(usuario).find('.campo').each(function () {


                    if (($(this).data('tipocampo') === 'text') ||
                        ($(this).data('tipocampo') === 'checkbox') ||
                        ($(this).data('tipocampo') === 'select') ||
                        ($(this).data('tipocampo') === 'date') ||
                        ($(this).data('tipocampo') === 'textarea') ||
                        ($(this).data('tipocampo') === 'selectmultiple') ||
                        ($(this).data('tipocampo') === 'selectmultipleinscripcion') ||
                        ($(this).data('tipocampo') === 'selectquery') ||
                        ($(this).data('tipocampo') === 'hora') ||
                        ($(this).data('tipocampo') === 'fijo') ||
                        ($(this).data('tipocampo') === 'eligible')) {
                        var input = $(this).find('.form-control');
                        if (input.length === 0) { // per checkbox i selectmultiple
                            input = $(this).find('.form-control2');
                        }

                        var name = '[campo][' + $(this).data('id_reg_plantilla_campo') + ']';
                        var newName = 'inscrito[' + key + ']' + name;

                        if (($(this).data('tipocampo') === 'selectmultiple') ||
                            ($(this).data('tipocampo') === 'selectmultipleinscripcion') ||
                            ($(this).data('tipocampo') === 'eligible') ||
                            ($(this).data('tipocampo') === 'fijo')) {
                            newName = 'inscrito[' + key + ']' + name + '[]';
                        }

                        if ($(this).data('id_reg_plantilla_campo') == -2) {
                            var documents_multiples = null;
                            for (i = 0; i < actividades.inscripcion.vue.usuarios[key].document.length; i++) {
                                if (documents_multiples === null) {
                                    documents_multiples = actividades.inscripcion.vue.usuarios[key].document[i];
                                } else {
                                    documents_multiples = documents_multiples + ",";
                                    documents_multiples = documents_multiples + actividades.inscripcion.vue.usuarios[key].document[i];
                                }
                            }
                            input.attr('value', documents_multiples);
                        }

                        input.attr('name', newName);
                    }
                });
            });
        },
        setDocument: function (num_usuari, filename, attach_id_campo) {
            var file_field = filename;
            if (typeof (attach_id_campo) !== 'undefined') {
                file_field = file_field + '?' + attach_id_campo;
            } else {
                file_field = file_field + '?-1';
            }
            actividades.inscripcion.vue.usuarios[num_usuari].document.push(file_field);
        },
        delDocument: function (num_usuari, filename) {
            for (var i = 0; i < actividades.inscripcion.vue.usuarios[num_usuari].document.length; i++) {
                var pos = actividades.inscripcion.vue.usuarios[num_usuari].document[i].indexOf('?');
                var filedocument = actividades.inscripcion.vue.usuarios[num_usuari].document[i].substr(0, pos);
                if (filedocument === filename) {
                    //actividades.inscripcion.vue.$delete( actividades.inscripcion.vue.usuarios[num_usuari].document, i);
                    actividades.inscripcion.vue.usuarios[num_usuari].document.splice(i, 1);
                    if (i === 0) {
                        return 1;
                    } else {
                        return 0;
                    }
                }
            }
            return 0;
        },
        mapa_de_localidades_por_fecha: function(id_reg_actividad_grupo, id_mst_recinto, fecha, isAdmin) {             
            $($('[name="id_reg_actividades_grupo_precio"]')[0]).closest('div').parent().parent().parent().html("<div class='btn btn-warning' id='localidades_preciototal'>" + Lang.get("factura.total") + ": 0€</div>");

            clearInterval(map_interval);

            axios.get("/api/actividades/mapa_de_localidades_por_fecha/" + id_reg_actividad_grupo + "/" + id_mst_recinto + "/" + fecha+"?isAdmin="+isAdmin)
                .then(function(res)  {                  
                    actividades.inscripcion.pintar_mapa_de_localidades(res.data, id_reg_actividad_grupo, id_mst_recinto, fecha, isAdmin);
                    map_interval = setInterval(function()  { actividades.inscripcion.mapa_de_localidades_por_fecha(id_reg_actividad_grupo, id_mst_recinto, fecha, isAdmin) }, 10000);
                });

        },
        pintar_mapa_de_localidades:function (data, id_reg_actividad_grupo, id_mst_recinto, fecha, isAdmin) {           
            var clase = "";          
            /*  $('.container').css('padding', '1px 40px');
             $('.container').removeClass('container'); */
            var localidades_html = '<div class="col-sm-12 text-center escenario">' + Lang.get("localidades.ESCENARI") + '</div>';
            var fila_actual = 1;
            var precio_total = 0;
            var localidades_marcadas = 0;
            var localidades_escogidas = "";
            data.localidades.forEach(function(localidad, index) {
              
                if (fila_actual != localidad.fila) {
                    localidades_html += "<div style='flex-basis:100%; height:0px; background-color:#fc0;'></div>";
                }
                data.estados.forEach(function (e)  {
                    if (e.id_mst_recinto_localidad_estado == localidad.id_mst_localidad_estado) {
                        clase = e.clase;                      
                        if (!isAdmin && clase == 'localidad_reservada') { clase = 'localidad_ocupada ' }                    
                    }
                })
                //0 localidad_disponible
                //1	localidad_asignada
                //2	localidad_ocupada
                //5	localidad_pasillo 
                if (!localidad.precio) {
                    if(localidad.precio_max){
                        localidad.precio = localidad.precio_max;}
                    else{
                        localidad.precio=0;
                    }
                }

                if (localidad.id_mst_localidad_estado === 1 ) {
                    precio_total += parseInt(localidad.precio);
                    localidades_marcadas++;
                    localidades_escogidas += "F" + localidad.fila + "C" + localidad.columna + "ID" + localidad.id_mst_recinto_localidad + ",";
                    $("#campo_precio_localidades_escogidas").val(precio_total);
                }

                localidades_marcadas === 0 ? $("#inscripcionFormularioSubmitBtn").hide() : $("#inscripcionFormularioSubmitBtn").show();
                $("#localidades_preciototal").html(Lang.get("factura.total") + " : " + precio_total + "€");
                $("#campo_localidades_escogidas").val(localidades_escogidas);
                $("#campo_precio_localidades_escogidas").val(precio_total);
                if (localidad.precio && localidad.precio.length > 4) {
                    localidad.precio = localidad.precio.substring(0, 4);
                }

                localidades_html += '<div  id="localidades_' + localidad.fila + '_' + localidad.columna + '" class="localidades ' + localidad.fila + ' ' + localidad.columna + '"';
                localidad.id_mst_localidad_estado == 0 || localidad.id_mst_localidad_estado == 1 || isAdmin ? localidades_html += ' onClick="actividades.inscripcion.cambiar_estado_de_localidad(' + id_reg_actividad_grupo + ',' + id_mst_recinto + ',' + localidad.fila + ',' + localidad.columna + ', \'' + fecha + '\','+isAdmin+')"' : '';
                localidades_html += '><div class="localidades_seat ' + clase + '">' + localidad.precio + '€</div>';
                localidad.fila.length < 2 ? localidad.fila = '-' + localidad.fila : '';
                localidad.id_mst_localidad_estado != 5 ? localidades_html += '<div class="localidad_numero"> F' + localidad.fila + ' C' + localidad.columna + '</div>' : '';
                localidades_html += '</div>';
                fila_actual = localidad.fila;
            })
            $("#actividad_mapa_de_localidades").html(localidades_html);


        },
        cambiar_estado_de_localidad:function (id_reg_actividad_grupo, id_mst_recinto, fila, columna, fecha,isAdmin) {
            axios.get("/api/actividades/cambiar_estado_de_localidad/" + id_reg_actividad_grupo + "/" + id_mst_recinto + "/" + fila + "/" + columna + "/" + fecha)
                .then(function (res)  {
                    if (res.data == 0) {                                  
                        $("#localidades_" + fila + "_" + columna).children('.localidades_seat').removeClass("localidad_asignada");
                        $("#localidades_" + fila + "_" + columna).children('.localidades_seat').addClass("localidad_disponible");
                    } else if (res.data == 1) {
                        $("#localidades_" + fila + "_" + columna).children('.localidades_seat').removeClass("localidad_disponible");
                        $("#localidades_" + fila + "_" + columna).children('.localidades_seat').addClass("localidad_asignada");
                    } else if (res.data == 2) {
                        alert("Seient no disponible");
                        $("#localidades_" + fila + "_" + columna).children('.localidades_seat').removeClass("localidad_disponible");
                        $("#localidades_" + fila + "_" + columna).children('.localidades_seat').addClass("localidad_ocupada");
                        $("#localidades_" + fila + "_" + columna).prop("onclick", null).off("click");
                    }
                });
            actividades.inscripcion.mapa_de_localidades_por_fecha(id_reg_actividad_grupo, id_mst_recinto, fecha,isAdmin);
        }


    },

    editar: {
        revisar_campos_iguales: function () {
            var plantilla_principal = $('#select_plantilla').val();
            var plantilla_secundaria = $('#select_plantilla_secundaria').val();

            if (plantilla_secundaria == 0) {
                return;
            }

            if (plantilla_principal == plantilla_secundaria) {
                document.getElementById('aviso_plantillas_iguales').style.display = 'block';
                document.getElementById('select_plantilla_secundaria').value = 0;
            } else {
                document.getElementById('aviso_plantillas_iguales').style.display = 'none';
            }

        },
        revisarCampos: function () {
            $("#actividades_grupos .actividadGrupo").each(function () {
                if ($(this).find('[name=crear_usuarios]').val() > 0) {
                    $(this).find(".crear_usuarios_anadir_etiqueta").removeClass('hidden');
                    $(this).find(".identificar_usuarios").removeClass('hidden');
                    if ($(this).find('[name=crear_usuarios]').val() > 1) {
                        $(this).find(".crear_usuarios_validar_nif_padron").removeClass('hidden');
                        $(this).find(".crear_usuarios_validar_nif_actividades_renovacion").removeClass('hidden');
                        $(this).find(".crear_usuarios_asignar_foto").removeClass('hidden');
                        $(this).find(".crear_usuarios_permitir_modificar_datos").removeClass('hidden');
                        $(this).find(".texto_tutor").removeClass('hidden');
                        $(this).find(".identificar_usuario").removeClass('hidden');
                        $(this).find(".no_permitir_duplicados").removeClass('hidden');
                        if ($(this).hasClass(".aceptar_inscritos")) $(this).find(".aceptar_inscritos").removeClass('hidden');
                    } else {
                        $(this).find(".crear_usuarios_validar_nif_padron").addClass('hidden');
                        $(this).find(".crear_usuarios_validar_nif_actividades_renovacion").addClass('hidden');
                        $(this).find(".crear_usuarios_asignar_foto").addClass('hidden');
                        $(this).find(".crear_usuarios_permitir_modificar_datos").addClass('hidden');
                        $(this).find(".texto_tutor").addClass('hidden');
                        $(this).find(".identificar_usuario").addClass('hidden');
                        $(this).find(".no_permitir_duplicados").addClass('hidden');
                        if (parseInt($('#select_plantilla option:selected').attr('es_nif')) === 0) {
                            // $(this).find(".aceptar_inscritos").addClass('hidden');
                            $('#aceptar_inscritos').addClass('hidden');
                        }
                    }
                    //$(this).find('.plantilla_secundaria').addClass('hidden');
                } else {
                    $(this).find(".crear_usuarios_anadir_etiqueta").addClass('hidden');
                    $(this).find(".crear_usuarios_validar_nif_padron").addClass('hidden');
                    $(this).find(".crear_usuarios_validar_nif_actividades_renovacion").addClass('hidden');
                    $(this).find(".crear_usuarios_asignar_foto").addClass('hidden');
                    $(this).find(".crear_usuarios_permitir_modificar_datos").addClass('hidden');
                    $(this).find(".texto_tutor").addClass('hidden');
                    $(this).find(".identificar_usuario").addClass('hidden');
                    $(this).find(".identificar_usuarios").addClass('hidden');
                    $(this).find(".no_permitir_duplicados").addClass('hidden');
                    $(this).find(".aceptar_inscritos").addClass('hidden');
                    $(this).find('#tipo_inscripcion').is(':checked') ? $(this).find(".plantilla_secundaria").removeClass('hidden') : $(this).find(".plantilla_secundaria").addClass('hidden');
                }
                $(this).find('[name=aceptar_condiciones]').is(':checked') ? $(this).find(".condiciones_texto_legal").removeClass('hidden') : $(this).find(".condiciones_texto_legal").addClass('hidden');
                $(this).find('[name=calcular_precio]').is(':checked') ? $(this).find(".multiples_precios").addClass('hidden') : $(this).find(".multiples_precios").removeClass('hidden');
                $(this).find('[name=generar_codigo_qr]').is(':checked') ? $(this).find(".qr_un_solo_uso").removeClass('hidden') : $(this).find(".qr_un_solo_uso").addClass('hidden');
                $(this).find('[name=actividad_permanente]').is(':checked') ? $(this).find(".fechas_permanentes").addClass('hidden') : $(this).find(".fechas_permanentes").removeClass('hidden');
                $(this).find('[name=solo_usuario_registrado]').is(':checked') ? $(this).find(".inscripcion_unica").removeClass('hidden') : $(this).find(".inscripcion_unica").addClass('hidden');
                if ($(this).find('[name=tipo_inscripcion]').is(':checked')) {
                    var $select_sorteo = $(this).find("select[name=actividad_con_sorteo]");
                    var tiene_aforo_opciones = parseInt($select_sorteo.attr('data-tiene-aforo-opciones') || '0') === 1;
                    var $opcion_sorteo2 = $select_sorteo.find('option[value="2"]');
                    var $opcion_sorteo3 = $select_sorteo.find('option[value="3"]');
                    var $opcion_sorteo4 = $select_sorteo.find('option[value="4"]');
                    if (!tiene_aforo_opciones) {
                        if ($select_sorteo.val() === '3' || $select_sorteo.val() === '4') {
                            $select_sorteo.val(0);
                        }
                        $opcion_sorteo3.addClass('hidden');
                        $opcion_sorteo4.addClass('hidden');
                    } else {
                        $opcion_sorteo3.removeClass('hidden');
                    }
                    if ($(this).find('input[name=tipo_inscripcion]:radio:checked').val() === '1') {
                        var valor_sorteo = $select_sorteo.val();
                        if (valor_sorteo === '2' || valor_sorteo === '4') {
                            $select_sorteo.val(0);
                        }
                        $opcion_sorteo2.addClass('hidden');
                        $opcion_sorteo4.addClass('hidden');
                    } else {
                        $opcion_sorteo2.removeClass('hidden');
                        if (tiene_aforo_opciones) {
                            $opcion_sorteo4.removeClass('hidden');
                        }
                    }
                }
                var total_tabs = $('#myActivities li').length;

                if ($(this).find('[name^="precios["][name$="][importe]"]').length == 0 || total_tabs > 1) {
                    $(this).find('[name=escoger_localidades]').bootstrapSwitch('readonly', true);
                    $("#localidades_check_precios").show();
                }else{
                    $(this).find('[name=escoger_localidades]').bootstrapSwitch('readonly', false);
                    $("#localidades_check_precios").hide();
                }

                $(this).find('[name=escoger_localidades]').is(':checked') ?
                    (function()  {
                        $("[name=calcular_precio]").bootstrapSwitch('readonly', true);
                        $("[name=calcular_precio]").bootstrapSwitch('state', false);
                        $("#escoger_localidades_on").removeClass('hidden');
                        $("[name=actividad_permanente]").bootstrapSwitch('readonly', true);
                        $("[name=actividad_permanente]").bootstrapSwitch('state', false);
                        $("[name=activar_pago_posterior]").bootstrapSwitch('readonly', true);


                        actividades.editar.escoger_localidades_rellenar_fechas();
                    })() :
                    (function()  {
                        $("#escoger_localidades_on").addClass('hidden');
                        $("[name=actividad_permanente]").bootstrapSwitch('readonly', false);
                        $("[name=activar_pago_posterior]").bootstrapSwitch('readonly', false);
                        $("[name=calcular_precio]").bootstrapSwitch('readonly', false);

                    })();
            });
        },
        condiciones_defecto_get: function () {
            axios.get('/api/parametro/TERMINOS_CONDICIONES/getParam').then(function (res) {
                $("[name=condiciones_texto_legal]").val(res.data.valor);
            });
        },
        revisar_aceptar_inscritos: function (event) {
            $.get('plantilla/tiene_tsi/' + event.target.selectedOptions[0].value, {}, function (res) {
                if (res.status == 0) {
                    if (res.data) {
                        document.getElementById('identificar_tsi').style.display = 'block';//Si es true el camp identificar_tsi es mostra
                    } else {
                        document.getElementById('identificar_tsi').style.display = 'none';//Si es false el camp identificar_tsi no es mostra
                        document.getElementById('identificar_usuarios').value = 0;//Es seteja a 0 perque no quedi seleccionat el camp TSI per error
                    }
                }
            });
        },
        revisar_permitir_pago_posterior: function (event) {
            var id_reg_plantilla = document.getElementById('select_plantilla').value;
            var crear_usuarios = document.getElementById('crear_usuarios').value;
            $.post('permitir_activar_pago_posterior', { id_reg_plantilla: id_reg_plantilla, crear_usuario: crear_usuarios }, function (result) {
                if (result.status == 0) {
                    if (result.data) {
                        $('#activar_pago_posterior').bootstrapSwitch('readonly', false);
                    } else {
                        $('#activar_pago_posterior').bootstrapSwitch('readonly', true);
                        $('#activar_pago_posterior').prop('checked', false).change();
                    }
                }
            });
        },
        revisar_datos_listaespera: function(grupo){
            var listaespera = $('#checkbox_actividad_listaespera'+grupo).prop('checked');
            var actividad_sorteo = 0;
            if ($('#actividad_con_sorteo').val() > 0) {
                actividad_sorteo = 1;
            }
            if (listaespera) {
                if(actividad_sorteo) {
                    $('#actividad_con_sorteo'+grupo).val(0);
                }
                $('#actividad_con_sorteo_om'+grupo).addClass('hidden');
                $('#activar_pago_posterior'+grupo).bootstrapSwitch('state', true);
                $('#activar_pago_posterior'+grupo).bootstrapSwitch('readonly', true);
                $('#activar_forzar_pago'+grupo).bootstrapSwitch('readonly', false);
            } else {
                $('#activar_pago_posterior'+grupo).bootstrapSwitch('readonly', false);
                $('#activar_forzar_pago'+grupo).bootstrapSwitch('state', false);
                $('#activar_forzar_pago'+grupo).bootstrapSwitch('readonly', true);
            }
        },
        revisar_datos_pago_posterior: function (grupo) {

            var pago_posterior = $('#activar_pago_posterior'+grupo).prop('checked');
            var listaespera = $('#checkbox_actividad_listaespera'+grupo).prop('checked');
            var actividad_sorteo = 0;
            if ($('#actividad_con_sorteo'+grupo).val() > 0) {
                actividad_sorteo = 1;
                $('#checkbox_actividad_listaespera'+grupo).bootstrapSwitch('readonly', true);
                $('#checkbox_actividad_listaespera'+grupo).addClass('hidden');
            } else {
                if (!listaespera) {
                    $('#checkbox_actividad_listaespera'+grupo).bootstrapSwitch('readonly', false);
                    $('#checkbox_actividad_listaespera'+grupo).removeClass('hidden');
                }

            }
            var ocults = document.getElementsByClassName('activar_pago_posterior_on'+grupo);
            var ocults_sorteo = document.getElementsByClassName('activar_sorteo_on'+grupo);
            var check_calculo = document.getElementById('checkbox_calculo_precio'+grupo);
            var check_pago = document.getElementById('checkbox_activar_pago'+grupo);
            if (pago_posterior || actividad_sorteo || listaespera) {//Ha activat el pago posterior

                $('#checkbox_activar_pago'+grupo).bootstrapSwitch('state', false);
                $('#checkbox_activar_pago'+grupo).bootstrapSwitch('readonly', true);
                check_pago.checked = false;

                $('#checkbox_calculo_precio'+grupo).bootstrapSwitch('state', true);
                $('#checkbox_calculo_precio'+grupo).bootstrapSwitch('readonly', true);
                check_calculo.checked = true;

                //document.getElementsByClassName('pedir_importe_fijo')[0].classList.remove('hidden');
            } else {//Encara ha d'activar el pago posterior
                // Sacamos readonly de los campos que se marcan al haber pago posterior
                $('#checkbox_activar_pago'+grupo).bootstrapSwitch('readonly', false);
                $('#checkbox_calculo_precio'+grupo).bootstrapSwitch('readonly', false);

                for (var i = 0; i < ocults.length; i++) {
                    ocults[i].classList.add('hidden');
                }
            }
            if (pago_posterior) {
                for (var i = 0; i < ocults.length; i++) {
                    ocults[i].classList.remove('hidden');
                }
            } else {
                for (var i = 0; i < ocults.length; i++) {
                    ocults[i].classList.add('hidden');
                }
                //Quan fa l'add, es fica l'importe_fijo a null ('').
                document.getElementById('importe_fijo').value = '';
                document.getElementsByClassName('pedir_importe_fijo')[0].classList.remove('hidden');
                document.getElementById('pedir_importe_fijo').value = 0;
            }
            if (actividad_sorteo) {
                for (var i = 0; i < ocults_sorteo.length; i++) {
                    ocults_sorteo[i].classList.remove('hidden');
                }
            } else {
                for (var i = 0; i < ocults_sorteo.length; i++) {
                    ocults_sorteo[i].classList.add('hidden');
                }
            }

        },
        revisar_importes_fijos: function () {
            var pedir_importe_fijo = document.getElementById('pedir_importe_fijo');
            var datos = document.getElementsByClassName('datos_mails_importe_fijo');
            if (pedir_importe_fijo.value == "1") {
                document.getElementById('importe_fijo').value = '';
                for (var i = 0; i < datos.length; i++) {
                    datos[i].classList.remove("hidden");
                }
            } else {
                document.getElementById('importe_fijo').value = '';
                for (var i = 0; i < datos.length; i++) {
                    datos[i].classList.add("hidden");
                }
            }
        },
        precio_fijo_cambiado: function () {//No es pot ficar un import negatiu
            var importe_fijo = $('#importe_fijo').val();
            if (importe_fijo <= 0) {
                $('#importe_fijo').val(0);
            } else {
                if ($('#precio_fijo_concepto').val() == '') {
                    $('#precio_fijo_concepto').val(Lang.get('inscripcion.IMPORTE_FIJO_INPUT'));
                }
            }
        },
        concepto_importe_fijo_cambiado: function () {
            //precio_fijo_concepto
            //importe_fijo
            var precio_fijo_concepto = document.getElementById('precio_fijo_concepto').value.trim();
            var importe_fijo = document.getElementById('importe_fijo').value;
            if (importe_fijo > 0 && precio_fijo_concepto == '') {
                document.getElementById('precio_fijo_concepto').value = Lang.get('inscripcion.IMPORTE_FIJO_INPUT');
            }

        },
        escoger_localidades_marcar: function (dia) {
            var index = localidades_fechas_elegidas.indexOf(dia);
            if (index === -1) {
                localidades_fechas_elegidas.push(dia);
                $('#' + dia + ' .dia').addClass('selected')
            } else {
                while (index !== -1) {
                    localidades_fechas_elegidas.splice(index, 1);
                    index = localidades_fechas_elegidas.indexOf(dia); // Find the next occurrence
                }
                $('#' + dia + ' .dia').removeClass('selected')
            }
            $("#localidades_dias_disponibles").val(localidades_fechas_elegidas);
        },

        escoger_localidades_rellenar_fechas: function () {
            $("#escoger_localidades_marcar_fechas_activar_btn").addClass('btn-success');
            $("#escoger_localidades_marcar_precios_activar_btn").removeClass('btn-success');
            $("#escoger_localidades_ver_aforo_activar_btn").removeClass('btn-success');

            var esta_guardat_array = $("#localidades_dias_guardados").val().length > 0 ? $("#localidades_dias_guardados").val().split(",") : [];
            $("#localidades_dias_disponibles").val($("#localidades_dias_guardados").val());
            $("#localidades_dias_guardados").val();

            $('#localidades_dias').html("");
            var months = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            var diassemana = ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"];
            var fecha_inicio = $("[name='fecha_inicio']").val().substr(0, 10);
            var fecha_fin = $("[name='fecha_fin']").val().substr(0, 10);
            //var [day, month, year] = fecha_inicio.split('/');
            var dateParts = fecha_inicio.split('/');
            var day = dateParts[0];
            var month = dateParts[1]; 
            var year = dateParts[2];
            fecha_inicio = new Date(year, month - 1, day);
            //var [day, month, year] = fecha_fin.split('/');
            var dateParts = fecha_fin.split('/');
            var day = dateParts[0];
            var month = dateParts[1]; 
            var year = dateParts[2];
            fecha_fin = new Date(year, month - 1, day);

            var localidades_dias_disponibles = [];

            localidades_fechas_elegidas = localidades_fechas_elegidas.concat(esta_guardat_array);         
            var fecha_actual = fecha_inicio;
            while (fecha_actual <= fecha_fin) {
                fecha_actual.setDate(fecha_actual.getDate() + 1);
                localidades_dias_disponibles.push(fecha_actual.toISOString().split('T')[0]);
            }

            localidades_dias_disponibles.forEach(function(dia_inicial)  {

                //var [year, month, day] = dia_inicial.split('-');
                var dateParts = dia_inicial.split('-');

                var year = dateParts[0];
                var month = dateParts[1];
                var day = dateParts[2];
                var dia = day;
                var mes = months[parseInt(month)];
                var dow = new Date(dia_inicial).getDay();

                var esta_marcat = localidades_fechas_elegidas.indexOf(dia_inicial);
                var selected;
                if (esta_marcat != -1) {
                    selected = " selected";
                } else {
                    selected = "";
                }
                $('#localidades_dias').append("<div class='" + esta_marcat + " localidades_dias_disponibles' id='" + dia_inicial + "' onclick=\"actividades.editar.escoger_localidades_marcar('" + dia_inicial + "')\"><div class='mes'>" + mes + "</div><div class='dia" + selected + "' >" + dia + "</div><div class='dow'>" + diassemana[dow] + "</div>");
                if (dow == 0) {
                    $('#localidades_dias').append("<div style='flex: 0 0 100%; height: 0; '>&nbsp;</div>");
                }
            })
        },
        escoger_localidades: function () {

            $("#localidades_precios").fadeOut();
            $("#localidades_aforo").fadeOut();

            actividades.editar.revisarCampos();

            var escoger_localidades = $('#checkbox_escoger_localidades').prop('checked');
            var ocults = document.getElementsByClassName('escoger_localidades_on');

            if (escoger_localidades) {
                $("[name = 'actividad_permanente'").bootstrapSwitch('state', false);
                $("[name = 'actividad_permanente'").bootstrapSwitch('readonly', true);
                /*    $("[name = 'solo_usuario_registrado'").bootstrapSwitch('state', true);
                        $("[name = 'solo_usuario_registrado'").bootstrapSwitch('readonly', true); */

                for (var i = 0; i < ocults.length; i++) {
                    ocults[i].classList.remove('hidden');
                    ocults[i].style.backgroundColor = '#ffA500';
                    (function (index) {
                        setTimeout(function() {
                            if (ocults[index]) {  // Check if the element exists
                                ocults[index].style.backgroundColor = 'transparent';
                            }
                        }, 1000);
                    })(i);
                }
                actividades.editar.escoger_localidades_rellenar_fechas();
            } else {
                for (var i = 0; i < ocults.length; i++) {
                    ocults[i].classList.add('hidden');
                }
            }

        },
        escoger_localidades_marcar_fechas_activar: function () {
            $("#escoger_localidades_marcar_fechas_activar_btn").addClass('btn-success');
            $("#escoger_localidades_marcar_precios_activar_btn").removeClass('btn-success');
            $("#escoger_localidades_ver_aforo_activar_btn").removeClass('btn-success');

            $("#localidades_precios").fadeOut();
            $("#localidades_dias").fadeIn().removeClass('hidden');
            $("#localidades_aforo").fadeOut();
        },
        escoger_localidades_marcar_precios_activar: function () {
            $("#escoger_localidades_marcar_fechas_activar_btn").removeClass('btn-success');
            $("#escoger_localidades_marcar_precios_activar_btn").addClass('btn-success');
            $("#escoger_localidades_ver_aforo_activar_btn").removeClass('btn-success');

            $("#localidades_dias").fadeOut();
            $("#localidades_precios").fadeIn().removeClass('hidden');
            $("#localidades_aforo").fadeOut();
        },
        escoger_localidades_ver_aforo_activar: function () {
            $("#escoger_localidades_marcar_fechas_activar_btn").removeClass('btn-success');
            $("#escoger_localidades_marcar_precios_activar_btn").removeClass('btn-success');
            $("#escoger_localidades_ver_aforo_activar_btn").addClass('btn-success');

            $("#localidades_dias").fadeOut();
            $("#localidades_aforo").fadeIn().removeClass('hidden');
            $("#localidades_precios").fadeOut();
            var fecha = $("#campo_localidades_fecha_escogida").val();
            var id_reg_actividades_grupo = $("[name='id_reg_actividades_grupo']").val();
            var id_mst_recinto = $("#localidades_recinto").val();
            actividades.inscripcion.mapa_de_localidades_por_fecha(id_reg_actividades_grupo, id_mst_recinto, fecha, true);
        },
        escoger_localidades_marcar_precios: function (id_precio) {
            var localidades_seleccionadas = $("#localidades_por_precio").val();

            var id_mst_recinto = $("#localidades_recinto").val();
            var id_reg_actividades_grupo = $("[name='id_reg_actividades_grupo']").val();
            var id_reg_actividades = $("[name='id_reg_actividades']").val();
            axios.get("/api/actividades/cambiar_precio_de_localidad/" + id_reg_actividades_grupo + "/" + id_mst_recinto + "/" + localidades_seleccionadas + "/" + id_precio)
                .then(function(res)  {
                    window.location.href = 'view/reserves/admin_actividades/actividad/' + id_reg_actividades + '#select-result';
                    window.location.reload(true);
                });
        }
    },
    inscritos: {
        mostrar: {
            vue: null,
            newVue: function () {
                actividades.inscritos.mostrar.vue = new Vue({
                    el: '.actividades_list_view',
                    data: {
                        activar_acceso: {
                            socio: { codigo_tarjeta_acceso: '' },
                            codigo: {},
                            todos: {},
                            recursos: {},
                            error_msg: null
                        }
                    },
                    methods: {
                        openModal: function (id_mst_socios) {
                            var self = this;
                            self.id_mst_socios = id_mst_socios;
                            self.activar_acceso.error_msg = null;

                            axios.get('/api/socio/' + self.id_mst_socios + '/activar_acceso_recurso_editar').then(function (res) {
                                self.activar_acceso.socio = res.data.socio;
                                self.activar_acceso.codigo = res.data.codigo;
                                self.activar_acceso.todos = res.data.todos;
                                self.activar_acceso.recursos = res.data.recursos;

                                $('#modalEditUser').modal('show');
                            });
                        },
                        closeModal: function () {
                            $('#modalEditUser').modal('hide');
                        },
                        saveChanges: function () {
                            var self = this;
                            axios.post('/api/socio/' + self.id_mst_socios + '/activar_acceso_recurso_editar',
                                {
                                    'socio': self.activar_acceso.socio,
                                    'codigo': self.activar_acceso.codigo,
                                    'todos': self.activar_acceso.todos,
                                    'recursos': self.activar_acceso.recursos
                                }).then(function (res) {
                                if (res.data.status == 1) {
                                    self.closeModal();
                                    //console.log(res.data);
                                    var td = $("#" + res.data.sociosRecursoTarjeta[0].id_mst_socios);
                                    //console.log(res.data.htmlRespuesta);
                                    //console.log(td);
                                    if (td !== undefined) {
                                        td.html(res.data.htmlRespuesta);
                                    }
                                } else {
                                    self.activar_acceso.error_msg = res.data.msg;
                                }
                            });
                        }
                    },
                    beforeMount: function () {
                    }
                })
            }
        }
    },
    recintos: {
        recinto_mapear: function () {
            setTimeout(function()  {
                if (confirm('Si es canvien els valors, es refarà la plantilla.')) { document.getElementById('remap').value = 1; document.getElementById('recinto_form').submit(); }
            }, 3000
            )
        },
        actualizar_estado_pasillo: function (id_mst_recinto, filas, columnas) {
            axios.get("/api/recinto/actualizar_estado_pasillo/" + id_mst_recinto + "/" + filas + "/" + columnas)
                .then(function(res) {
                    if (res.statusText == 'OK') {
                        if (res.data == 1) {
                            $("#localidad_" + id_mst_recinto + "_" + filas + "_" + columnas).removeClass("localidad_disponible");
                            $("#localidad_" + id_mst_recinto + "_" + filas + "_" + columnas).addClass("localidad_pasillo");
                        } else {
                            $("#localidad_" + id_mst_recinto + "_" + filas + "_" + columnas).addClass("localidad_disponible");
                            $("#localidad_" + id_mst_recinto + "_" + filas + "_" + columnas).removeClass("localidad_pasillo");
                        }
                    } else {
                        //console.log(res);
                    }
                });

        },
        actualizar_estado_pasillo_entero: function (id_mst_recinto, valor, tipo) {
            var filas_totales = $("[name=filas_recinto]").val();
            var columnas_totales = $("[name=columnas_recinto]").val();

            if (tipo == 'columna') {
                $("#localidad_boton_vertical_" + valor).css("visibility", "hidden");
            }

            if (tipo == 'fila') {
                $("#localidad_boton_horizontal_" + valor).css("visibility", "hidden");
            }

            axios.get("/api/recinto/actualizar_estado_pasillo_entero/" + id_mst_recinto + "/" + valor + "/" + tipo)
                .then(function(res)  {
                    var status_color_actual;
                    var status_color;
                    if (res.data == 'mark') {
                        status_color_actual = 'localidad_disponible';
                        status_color = 'localidad_pasillo';
                    } else {
                        status_color_actual = 'localidad_pasillo';
                        status_color = 'localidad_disponible';
                    }
                    if (tipo == 'columna') {
                        $("#localidad_boton_vertical_" + valor).css("visibility", "visible");
                        for (var y = 1; y <= filas_totales; y++) {
                            $("#localidad_" + id_mst_recinto + "_" + y + "_" + valor).removeClass(status_color_actual);
                            $("#localidad_" + id_mst_recinto + "_" + y + "_" + valor).addClass(status_color);
                        }
                    }
                    if (tipo == 'fila') {
                        $("#localidad_boton_horizontal_" + valor).css("visibility", "visible");
                        for (var y = 1; y <= columnas_totales; y++) {
                            $("#localidad_" + id_mst_recinto + "_" + valor + "_" + y).removeClass(status_color_actual);
                            $("#localidad_" + id_mst_recinto + "_" + valor + "_" + y).addClass(status_color);
                        }
                    }
                });
        }
    }

}

function getUsuarioActualNoVue(e, id_reg_plantilla) {
    e.preventDefault();
    axios.get('/api/socio/getUsuarioActual').then(function (res) {
        axios.get('/api/plantilla/getUserFields/' + id_reg_plantilla).then(function (resPlantilla) {
            llenarCamposPlantillaSocio(res.data, resPlantilla.data, 0);
        });
    });
}

function redondear_hora_15m(elem) {
    var hora_muinuto = $(elem).val();
    var hora = hora_muinuto.split(':')[0];
    var minuto = hora_muinuto.split(':')[1];
    if (minuto == '01' || minuto == '02' || minuto == '03' || minuto == '04' || minuto == '05' || minuto == '06' || minuto == '07' ||
        minuto == '53' || minuto == '54' || minuto == '55' || minuto == '56' || minuto == '57' || minuto == '58' || minuto == '59') {
        minuto = '00';
    }
    if (minuto == '08' || minuto == '09' || minuto == '10' || minuto == '11' || minuto == '12' || minuto == '13' || minuto == '14' ||
        minuto == '16' || minuto == '17' || minuto == '18' || minuto == '19' || minuto == '20' || minuto == '21' || minuto == '22') {
        minuto = '15';
    }
    if (minuto == '23' || minuto == '24' || minuto == '25' || minuto == '26' || minuto == '27' || minuto == '28' || minuto == '29' ||
        minuto == '31' || minuto == '32' || minuto == '33' || minuto == '34' || minuto == '35' || minuto == '36' || minuto == '37') {
        minuto = '30';
    }
    if (minuto == '38' || minuto == '39' || minuto == '40' || minuto == '41' || minuto == '42' || minuto == '43' || minuto == '44' ||
        minuto == '46' || minuto == '47' || minuto == '48' || minuto == '49' || minuto == '50' || minuto == '51' || minuto == '52') {
        minuto = '45';
    }

    var hora_final = hora + ':' + minuto;
    $(elem).val(hora_final);
}

function eliminar_imagen(id_delete, id_reg_actividades_inscritos_attachment) {

    $.get('eliminar_fichero/' + id_reg_actividades_inscritos_attachment, function (result) {
        if (result.status == 0) {
            document.getElementById('attach' + id_delete).style.display = 'none';
        }
    });
}


function selUsuarioNoVue(e, id_reg_plantilla) {
    e.preventDefault();
    esVue = false;
    esAdmin = true;
    sel_soci_get_users({
        'name': '00000',
        'id_inscrito': 0
    });
}

function llenarCamposPlantillaSocio(datosSocio, datosPlantilla, key) {
    var usuario_actual = datosSocio;
    var busquem = null;
    var pos = parseInt(key) + 1;
    var $panel_inscrito = $('.usuarios .panel.panel-default.usuario').eq(parseInt(key));
    var $panel_filtros = $panel_inscrito.length ? $panel_inscrito : null;
    for (var i = 0; i <= datosPlantilla.length - 1; i++) {
        var campo = datosPlantilla[i];
        busquem = '#id' + pos + '_' + datosPlantilla[i].id_reg_plantilla_campo;
        var $campo_actual = $(busquem);
        switch (datosPlantilla[i].campo_mst_socios) {
            case 'nombre': $campo_actual.val(usuario_actual.nombre);
                break;
            case 'apellidos': $campo_actual.val(usuario_actual.apellidos);
                break;
            case 'numsocio': $campo_actual.val(usuario_actual.numsocio);
                break;
            case 'nif': $campo_actual.val(usuario_actual.nif);
                break;
            case 'direccion': $campo_actual.val(usuario_actual.direccion);
                break;
            case 'poblacion': $campo_actual.val(usuario_actual.poblacion);
                break;
            case 'codigo_postal': $campo_actual.val(usuario_actual.codigo_postal);
                break;
            case 'fecha_nac':
                if ((usuario_actual.fecha_nac.substring(0, 10)) !== '0000-00-00') {
                    $campo_actual.val(usuario_actual.fecha_nac.substring(0, 10));
                    $campo_actual.trigger('change');
                }
                break;
            case 'email': $campo_actual.val(usuario_actual.email);
                break;
            case 'observaciones': $campo_actual.val(usuario_actual.observaciones);
                break;
            case 'telefono': $campo_actual.val(usuario_actual.telefono);
                break;
            case 'iban': $campo_actual.val(usuario_actual.full_iban);
                break;
            case 'tsi': $campo_actual.val(usuario_actual.tsi);
                break;
        }

        var $panel = $campo_actual.closest('.panel.panel-default.usuario');
        if (!$panel.length) {
            $panel = $campo_actual.closest('.panel.panel-default');
        }
        if ($panel.length) {
            $panel_filtros = $panel;
        } else if ($panel_filtros && $panel_filtros.length) {
            $panel = $panel_filtros;
        }
        var $fecha_input = $panel.find('input.es_naixament');

        if($fecha_input.length == 0){
            var $nuevo_input = $('<input>', {
                type: 'hidden',
                class: 'es_naixament'
            });
            if (usuario_actual.fecha_nac) {
                $nuevo_input.val(usuario_actual.fecha_nac.substring(0, 10));
                $panel.find('.panel-body').prepend($nuevo_input);
                $nuevo_input.trigger('change');    
            }     
        }

        // Buscando el checkbox asociado al campo.
        var $checkbox = $(busquem).find('input[type="checkbox"]');
        if ($checkbox.is(':checked')) {
            $checkbox.trigger('click');
        }
        var $date = $(busquem).find('input[type="date"]');
        $date.val('');
        
        // Si el usuario tiene etiquetas y el campo tiene una etiqueta asociada comprobar si la tiene asignada.
        if (campo.id_mst_etiqueta_perfil > 0 && usuario_actual.etiquetas) {
            var fecha_caducidad = null;
            var etiqueta_existe = usuario_actual.etiquetas.some(function(et) {
                fecha_caducidad = et.fecha_caducidad;
                return et.id_mst_etiqueta === campo.id_mst_etiqueta_perfil;
            });

            if (etiqueta_existe) {
                var $checkbox = $(busquem).find('input[type="checkbox"]');
                $checkbox.trigger('click');
                if(fecha_caducidad) $date.val(fecha_caducidad);
            }
         }
    }

    var $ultimo_panel = $panel_filtros && $panel_filtros.length ? $panel_filtros : $('.panel.panel-default').eq(pos - 1);
    var etiquetas = usuario_actual.etiquetas.map(function(item) {
        return item.id_mst_etiqueta.toString();
    });
    aplicar_filtros($ultimo_panel, etiquetas);
}

function limpiar_campos_plantilla_socio(datosPlantilla, key) {
    var busquem = null;
    var pos = parseInt(key) + 1;
    for (var i = 0; i <= datosPlantilla.length - 1; i++) {
        var campoMstSocios = datosPlantilla[i].campo_mst_socios;
        if (!campoMstSocios) {
            continue;
        }

        busquem = '#id' + pos + '_' + datosPlantilla[i].id_reg_plantilla_campo;
        switch (campoMstSocios) {
            case 'nombre':
            case 'apellidos':
            case 'numsocio':
            case 'nif':
            case 'direccion':
            case 'poblacion':
            case 'codigo_postal':
            case 'fecha_nac':
            case 'email':
            case 'observaciones':
            case 'telefono':
            case 'iban':
            case 'tsi':
                $(busquem).val('');
                $(busquem).trigger('change');
                break;
        }
    }
}

function limpiar_dropzone_foto_perfil(key) {
    var pos = parseInt(key) + 1;
    var selector = '.attachmentUpload[data-es-foto="1"][id^="id' + pos + '_"]';
    $(selector).each(function () {
        var dz = this.dropzone;
        if (!dz) {
            return;
        }
        dz.removeAllFiles(true);
        limpiar_documento_foto_perfil(key, $(this).data('attach_id_reg_plantilla_campo'));
    });
}

function limpiar_documento_foto_perfil(key, attach_id_campo) {
    if (
        typeof actividades === 'undefined' ||
        !actividades.inscripcion ||
        !actividades.inscripcion.vue ||
        !actividades.inscripcion.vue.usuarios[key] ||
        typeof attach_id_campo === 'undefined'
    ) {
        return;
    }

    var documentos = actividades.inscripcion.vue.usuarios[key].document;
    for (var i = documentos.length - 1; i >= 0; i--) {
        var pos = documentos[i].indexOf('?');
        if (pos > -1 && documentos[i].substr(pos + 1) == attach_id_campo) {
            documentos.splice(i, 1);
        }
    }
}

function registrar_documento_foto_perfil(key, dz, profile_image) {
    if (
        !profile_image ||
        typeof actividades === 'undefined' ||
        !actividades.inscripcion ||
        !actividades.inscripcion.vue ||
        !actividades.inscripcion.vue.usuarios[key]
    ) {
        return;
    }

    var attach_id_campo = $(dz.element).data('attach_id_reg_plantilla_campo');
    var filename = profile_image.split('?')[0].split('/').pop();
    if (!filename) {
        return;
    }

    limpiar_documento_foto_perfil(key, attach_id_campo);
    actividades.inscripcion.setDocument(key, filename, attach_id_campo);
}

function recargar_dropzone_foto_perfil(key, profile_image) {
    var ruta = (profile_image || '').toString().trim();
    if (!ruta || ruta === 'img/user.png' || ruta === '/img/user.png') {
        return;
    }

    var pos = parseInt(key) + 1;
    var selector = '.attachmentUpload[data-es-foto="1"][id^="id' + pos + '_"]';
    $(selector).each(function () {
        var dz = this.dropzone;
        if (!dz) {
            return;
        }

        $(dz.element).attr('data-profile-image-path', ruta);
        if (dz.files && dz.files.length > 0) {
            dz.removeAllFiles(true);
        }

        var mockFile = { name: 'foto_perfil', size: 12345, accepted: true };
        if (typeof dz.displayExistingFile === 'function') {
            dz.displayExistingFile(mockFile, ruta, null, null, false);
        } else {
            dz.emit("addedfile", mockFile);
            dz.emit("thumbnail", mockFile, ruta);
            dz.emit("complete", mockFile);
            dz.files.push(mockFile);
        }

        if (dz.files.indexOf(mockFile) === -1) {
            dz.files.push(mockFile);
        }
        dz.emit("maxfilesreached", dz.files);
        dz.emit("maxfilesexceeded", mockFile);
        registrar_documento_foto_perfil(key, dz, ruta);
    });
}

$(document).off('click', ".dropzone_custom.document .btn-danger").on('click', ".dropzone_custom.document .btn-danger", function () {
    var self = $(this);
    var data = {
        id: self.closest('.document').data('id')
    };
    confirmDialog(Lang.get('msg.confirm_delete'))
        .yes(function () {
            $.post('/api/actividades/actividades_grupo/documentDelete', data, function () {
                dropzone.documentPreview(self.closest('.dropzone_custom'));
            })
        });
});

$(document).on('click', '.imprimirInscrito', function () {
    $("#inscritosViewTable tr").removeClass('printing');
    $(this).closest('tr').addClass('printing');
    var id_reg_actividades_inscritos = $("#inscritosViewTable tr.printing").data('id_reg_actividades_inscritos');

    $.get('/view/reserves/actividad/actividad_grupo/inscripcioprint/' + id_reg_actividades_inscritos, {}, function (inscripcio) {
        $("#imprimirInscritoModalBody").html(inscripcio);
        $("#imprimirInscritoModal").css('z-index', '1060');
        $("#imprimirInscritoModal").modal('show');
    });
});

$(document).on('click', '#modalPagoAdminOk', function () {
    $("#modalPagoAdmin").modal('hide');
    $('.modal-backdrop').remove();
    $('#modalPagoAdmin').removeClass('modal-open');
    $('#modalPagoAdmin').css('padding-right', '');
});

$(document).on('click', '#imprimirInscritoConfirma', function () {
    // Convert the DOM element to a drawing using kendo.drawing.drawDOM
    var divInscripcio = $('#imprimirInscritoModalBody');
    var pdfNombre = $(".inscripcio-title").text() + " " + $(".grupo-title").text() + ".pdf";
    var containerWrap = $('<div class="pdfContainer full-container campeonatoCategory"/>');
    containerWrap.append($(divInscripcio).html());
    containerWrap.find('.pdf_remove').remove();
    $('body').append(containerWrap);
    kendoDomtoDrawing(containerWrap, pdfNombre);
    // console.log('after print');
});

$(document).on('click', '#emailInscritoConfirma', function (event) {
    var divInscripcio = $('#emailInscritoModalBody');
    var email = $("#email_inscripcio").val();
    if (email.toString().trim() == '') {
        var html = '<h4 class="alert alert-warning">' + Lang.get("msg.operacio_realitzada_error") + '</h4>';
        $("#emailInscritoModalBodyMessage").html(html);
        $("#emailInscritoModalResult").css('z-index', '1060');
        $("#emailInscritoModalResult").modal('show');
        return;
    }
    var id_reg_actividades_inscritos = $("#email_inscripcio").data('id_reg_actividades_inscritos');
    var correo_original = $("#correo" + id_reg_actividades_inscritos).val();
    document.getElementById('correo' + id_reg_actividades_inscritos).value = email;
    //var td = $("." + email + id_reg_actividades_inscritos).find();
    var td = document.getElementsByClassName(correo_original + id_reg_actividades_inscritos)[0];
    td.innerText = email;
    td.classList.remove(correo_original + id_reg_actividades_inscritos);
    td.classList.add(email + id_reg_actividades_inscritos);
    var data = {
        email: email
    };

    $.post('/api/actividades/mail_pdf_inscripcion/' + id_reg_actividades_inscritos, data, function (res) {
        if (res >= 1) {
            var html = '<h4 class="alert alert-success">' + Lang.get("msg.notificacio_enviada_correctament") + '</h4>';
        } else {
            var html = '<h4 class="alert alert-warning">' + Lang.get("msg.operacio_realitzada_error") + '</h4>';
        }
        $("#emailInscritoModalBodyMessage").html(html);
        $("#emailInscritoModalResult").css('z-index', '1060');
        $("#emailInscritoModalResult").modal('show');
    });
});

$(document).on('click', '.sustituirOtorgado', function () {
    $("#inscritosViewTable tr").removeClass('sustituir');
    $(this).closest('tr').addClass('sustituir')
    $("#sustituirOtorgadoModal").modal('show');
});

$(document).on('click', '.sustituirOtorgadoConfirma', function () {
    var id_reg_actividades_inscritos = $("#inscritosViewTable tr.sustituir").data('id_reg_actividades_inscritos');
    $("#sustituirOtorgadoModal").modal('hide');
    $('#modal_c').modal('hide');
    $.post('/api/actividades/sustitucion_inscrito_sorteo/' + id_reg_actividades_inscritos, {}, function (res) {

    });
});



$(document).on('keyup', '.actividad_search_table', function () {

    if ($(this).val().length > 3) {
        sel_soci_get_users({
            'name': $(this).val(),
            'id_inscrito': num_inscrito_sel,
            'mostrar_name': true
        });
    }
});

$(function () {
    $("#inscripcionFormulario").length > 0 ? actividades.inscripcion.newVue() : 0;
    $(".ver_inscritos_btn").length > 0 ? actividades.inscritos.mostrar.newVue() : 0;
});
function sel_soci_get_users(object) {

    if (object.mostrar_name == null) {
        $("#select_socios_modal [name=search]").val('');
    }

    var name = object.name;
    var id_inscrito = object.id_inscrito;
    var sociosModal = $("#select_socios_modal");
    var sociosModalMessage = $("#select_socios_modal .message");
    sociosModalMessage.addClass('hidden');

    var excluded_ids = [-1];

    $.get('/sportssuite/manager.php?op=get_user_list&name=' + name + '&lvl=0' + '&exclude_ids=' + excluded_ids, function (res) {

        var showNif = 0;
        if (typeof (res.data.showNif) !== 'undefined' && res.data.showNif == '1') {
            var showNif = 1;
        }
        var showTlf = 0;
        if (typeof (res.data.showTlf) !== 'undefined' && res.data.showTlf == '1') {
            var showTlf = 1;
        }

        sociosModal.modal({ backdrop: 'static' }, 'show');

        var sociosModalTableTbody = $("#select_socios_modal table tbody");
        sociosModalTableTbody.empty();

        var trContent = '';
        if (res.data.socios !== null) {
            $.each(res.data.socios, function (index, value) {
                var nombre = value.n;
                if (showTlf == 1 && value.t !== null) {
                    nombre = nombre + '<br/>' + value.t;
                }
                if (showNif == 1 && value.nif !== null) {
                    nombre = nombre + '<br/>' + value.nif;
                }
                trContent += '<tr><td><div class="nameFriendly hidden">';
                trContent += removeDiacritics(nombre) + '</div><div><label><a class="select_socios_modal_checkbox btn btn-default" style="margin:0px;" data-id="' + value.id + '" data-nombre="' + value.n + '" data-inscrito="' + id_inscrito + '">OK</a></label></div></td><td>'
                trContent += nombre + '</td></tr>';
            });
        }

        sociosModalTableTbody.append(trContent);
    });

    $('#select_socios_modal').on('shown.bs.modal', function (e) {
        $('#search_input_socios').focus();
    });

    //Escollim l'usuari de dins el modal, en cal_event
    $('body').off('click', '#select_socios_modal .select_socios_modal_checkbox');
    $('body').on('click', '#select_socios_modal .select_socios_modal_checkbox', function (e) {
        // Les dades les obtindrem de l'element apretat
        var target = e.target;
        var id = target.attributes['data-id'].value;
        var key = target.attributes['data-inscrito'].value;
        var id_reg_plantilla = $('#idRegPlantilla').val();
        $("#select_socios_modal").modal('hide');
        axios.get('/api/socio/getUsuarioById/' + id).then(function (res) {
            if (esVue) {
                // actividades.inscripcion.vue.llenar_campos_con_mis_datos_btn = false;
                actividades.inscripcion.vue.usuario_actual = res.data;
                actividades.inscripcion.vue.usuarios[key].nombre = actividades.inscripcion.vue.usuario_actual.nombre;
                actividades.inscripcion.vue.usuarios[key].apellidos = actividades.inscripcion.vue.usuario_actual.apellidos;
                actividades.inscripcion.vue.usuarios[key].nif = actividades.inscripcion.vue.usuario_actual.nif;
                actividades.inscripcion.vue.usuarios[key].email = actividades.inscripcion.vue.usuario_actual.email;
                actividades.inscripcion.vue.usuarios[key].campos_disabled = true;
                actividades.inscripcion.vue.usuarios[key].campos_disabled_nif = true;

                if ($('#crearUsuariosPermitirModificarDatos').val() === '0') {
                    actividades.inscripcion.vue.usuarios[key].campos_disabled2 = true;
                } else {
                    actividades.inscripcion.vue.usuarios[key].campos_disabled2 = false;
                }
            }

            // li hem de passar el index per saber si omple de la primera index 0 o de la segona(si hi és) index >0
            axios.get('/api/plantilla/getUserFields/' + id_reg_plantilla).then(function (resPlantilla) {
                llenarCamposPlantillaSocio(res.data, resPlantilla.data, key);
                var rutaImagen = (res.data.path_imagen || '').toString().trim();
                if (rutaImagen && rutaImagen !== 'img/user.png' && rutaImagen !== '/img/user.png') {
                    recargar_dropzone_foto_perfil(key, rutaImagen);
                } else {
                    limpiar_dropzone_foto_perfil(key);
                }
            });
        });
    });
}
